import { render, staticRenderFns } from "./ActualiteProduct.vue?vue&type=template&id=ffeef31e&"
import script from "./ActualiteProduct.vue?vue&type=script&lang=js&"
export * from "./ActualiteProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports